module.exports = __webpack_public_path__ + "assets/img/footer1.d985854e.png";